import { convertUTCToDateBarFormat } from 'utils/utils';
import { BROWSER_TZ } from './constants';

export const formatDate = (orderDate: string) => {
	const { date, time } = convertUTCToDateBarFormat(orderDate, BROWSER_TZ);
	return `${date} | ${time}`;
};
